import NewsListBlock from "./NewsListBlock";

export default NewsListBlock;
